import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useFormControlContext } from '@mui/base/FormControl';
import Input from '@mui/material/Input';

import { inputClasses } from '@mui/base/Input';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/system';
import clsx from 'clsx';
import { IconButton, InputLabel, MenuItem, Select } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useAddCandidate } from '../../hooks/useCandidate';
import { SELECTED_MENU_PROPS } from '../StyledComponents/StyledComponent';



export default function Addcandidate({ open, close }) {
  const handleClose = () => {
    close();
  };

  // Initialize state
  const [formData, setFormData] = React.useState({
    firstName: '',
    lastName: '',
    phoneNumber: '',
    email: '', // Changed from emailAddress to email
    applyingFor: '',
    jobType: '',
    experience: '',
    currentCompany: '',
    resume: null,
    currentLocation: '',
  });

  const addCandidate = useAddCandidate();

  // Handle input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (event) => {
    const { name, files } = event.target;
    if (files.length > 0) {
      const file = files[0];
      setFormData({
        ...formData,
        [name]: file, // Store the file object
      });
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await addCandidate.mutateAsync(formData);
      // console.log(formData); // Logs the form data to the console
      handleClose(); // Close the modal after submission
    } catch (error) {
      console.error('Error adding candidate:', error);
      // Optionally, show error feedback to the user here
    }
  };

  return (
    <div>
      <Box>
        <Box
          sx={{
            justifyContent: 'space-between',
            alignItems: 'center',
            display: 'flex',
          }}
        >
          <Typography
            sx={{
              fontWeight: '700',
              fontSize: '24px',
              textAlign: 'center',
              color: '#2a2525!important',
              display: 'inline-block',
            }}
            id="modal-modal-title"
            variant="h6"
            component="h2"
          >
            Apply Now
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={6} md={4}>
            <Label>First Name</Label>
            <StyledInput
              name="firstName"
              value={formData.firstName}
              onChange={handleInputChange}
              placeholder="Write your first name here"
            />
            <HelperText />
          </Grid>
          <Grid item xs={6} md={4}>
            <Label>Last Name</Label>
            <StyledInput
              name="lastName"
              value={formData.lastName}
              onChange={handleInputChange}
              placeholder="Write your last name here"
            />
            <HelperText />
          </Grid>
          <Grid item xs={6} md={4}>
            <Label>Phone Number</Label>
            <StyledInput
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleInputChange}
              placeholder="Write your phone number here"
            />
            <HelperText />
          </Grid>
          <Grid item xs={6} md={4}>
            <Label>Email Address</Label>
            <StyledInput
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Write your email here"
            />
            <HelperText />
          </Grid>
          <Grid item xs={6} md={4}>
            <InputLabel>Applying for</InputLabel>
            <Select
              sx={{
                height: '40px',
                backgroundColor: '#fff',
                marginTop: '8px',
                marginBottom: '8px',
                '&:hover': {
                  '&& fieldset': {
                    border: '1px solid #42a5f5',
                  },
                },
              }}
              name="applyingFor"
              value={formData.applyingFor}
              onChange={handleInputChange}
              fullWidth
              displayEmpty
              MenuProps={SELECTED_MENU_PROPS}
            >
              <MenuItem value="">Select Position</MenuItem>
              <MenuItem value="Frontend Developer">Frontend Developer</MenuItem>
              <MenuItem value="Backend Developer">Backend Developer</MenuItem>
              <MenuItem value="Full Stack Developer">
                Full Stack Developer
              </MenuItem>
            </Select>
          </Grid>
          <Grid item xs={6} md={4}>
            <InputLabel>Job Type</InputLabel>
            <Select
              sx={{
                height: '40px',
                backgroundColor: '#fff',
                marginTop: '8px',
                marginBottom: '8px',
                '&:hover': {
                  '&& fieldset': {
                    border: '1px solid #42a5f5',
                  },
                },
              }}
              name="jobType"
              value={formData.jobType}
              onChange={handleInputChange}
              fullWidth
              displayEmpty
              MenuProps={SELECTED_MENU_PROPS}
            >
              <MenuItem value="">Select Job Type</MenuItem>
              <MenuItem value="Full Time">Full Time</MenuItem>
              <MenuItem value="Part Time">Part Time</MenuItem>
              <MenuItem value="Contract">Contract</MenuItem>
              <MenuItem value="Internship">Internship</MenuItem>
            </Select>
          </Grid>
          <Grid item xs={6} md={4}>
            <Label>Total Years Of Experience</Label>
            <StyledInput
              name="experience"
              value={formData.experience}
              onChange={handleInputChange}
              placeholder="Write your experience in years"
            />
            <HelperText />
          </Grid>
          <Grid item xs={6} md={4}>
            <Label>Current Company</Label>
            <StyledInput
              name="currentCompany"
              value={formData.currentCompany}
              onChange={handleInputChange}
              placeholder="Write your current company name here"
            />
            <HelperText />
          </Grid>
          <Grid item xs={6} md={4}>
            <Label>Upload Resume</Label>
            <StyledInput
              type="file" // Set type to file
              name="resume"
              onChange={handleFileChange} // Use file handler
              inputProps={{ accept: '.pdf,.doc,.docx' }} // Optional: Restrict file types
            />
            {formData.resume && (
              <Typography variant="body2" sx={{ marginTop: '8px' }}>
                {formData.resume.name} {/* Display the file name */}
              </Typography>
            )}
            <HelperText />
          </Grid>
          <Grid item xs={6} md={4}>
            <Label>Current Location</Label>
            <StyledInput
              name="currentLocation"
              value={formData.currentLocation}
              onChange={handleInputChange}
              placeholder="Write your current location here"
            />
            <HelperText />
          </Grid>
        </Grid>
        <Button
          variant="contained"
          sx={{
            border: '1px solid #36B0FF',
            backgroundColor: '#0E1F3A',
            color: 'white',
            mt: 2,
            '&:hover': {
              backgroundColor: '#0E1F3A',
              border: '1px solid #0E1F3A',
              opacity: '0.7',
            },
          }}
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </Box>
    </div>
  );
}

const StyledInput = styled(Input)(
  ({ theme }) => `

  .${inputClasses.input} {
    width: 320px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 8px;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    box-shadow: 0px 2px 2px ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};

    &:hover {
      border-color: ${blue[400]};
    }

    &:focus {
      outline: 0;
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
    }
  }
`
);

const Label = styled(({ children, className }) => {
  const formControlContext = useFormControlContext();
  const [dirty, setDirty] = React.useState(false);

  React.useEffect(() => {
    if (formControlContext?.filled) {
      setDirty(true);
    }
  }, [formControlContext]);

  if (formControlContext === undefined) {
    return <p>{children}</p>;
  }

  const { error, required, filled } = formControlContext;
  const showRequiredError = dirty && required && !filled;

  return (
    <p className={clsx(className, error || showRequiredError ? 'invalid' : '')}>
      {children}
      {required ? ' *' : ''}
    </p>
  );
})`
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 0.875rem;
  margin-bottom: 4px;

  &.invalid {
    color: red;
  }
`;

const HelperText = styled((props) => {
  const formControlContext = useFormControlContext();
  const [dirty, setDirty] = React.useState(false);

  React.useEffect(() => {
    if (formControlContext?.filled) {
      setDirty(true);
    }
  }, [formControlContext]);

  if (formControlContext === undefined) {
    return null;
  }

  const { required, filled } = formControlContext;
  const showRequiredError = dirty && required && !filled;

  return showRequiredError ? <p {...props}>This field is required.</p> : null;
})`
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 0.875rem;
`;

const blue = {
  100: '#DAECFF',
  200: '#b6daff',
  400: '#3399FF',
  500: '#007FFF',
  600: '#0072E5',
  900: '#003A75',
};

const grey = {
  50: '#F3F6F9',
  100: '#E5EAF2',
  200: '#DAE2ED',
  300: '#C7D0DD',
  400: '#B0B8C4',
  500: '#9DA8B7',
  600: '#6B7A90',
  700: '#434D5B',
  800: '#303740',
  900: '#1C2025',
};
